const checkExisting = (data, moduleId) => {
  let isExist = data.find((item) => item.parentId == moduleId);
  return isExist;
};

export { checkExisting };
